// extracted by mini-css-extract-plugin
export default {"wrap":"Manual_wrap__A+PcO","line":"Manual_line__nNUaO","text":"Manual_text__Rpfuy"};